import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { proposalApi } from '@modules/proposals/api';
import { CreateProposalRequestDto } from '@modules/proposals/api/dto/createProposal.dto';
import queryClient from '@app/queryClient';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';

const useCreateProposal = () => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['createProposal'],
    mutationFn: (body: CreateProposalRequestDto) =>
      proposalApi.createProposal(body),
    onMutate: () => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_CREATION_ATTEMPTED, { useContext: true });
    },
    onSuccess: () => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_CREATION_COMPLETED, { useContext: true });
      queryClient.refetchQueries({ queryKey: ['proposalsList'] });
      toast('info', { message: 'Proposal created' });
    },
    onError: (e) => {
      trackAmplitudeEvent(USER_EVENTS.PROPOSAL.PROPOSAL_CREATION_FAILED, {
        useContext: true,
        error_message: e.message,
      });
      toast('error', { message: e.message });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useCreateProposal;
